import { memo } from "react";
import type { BatchJobPanelProps } from "../../batch_job_kind_contract";
import { DocumentSectionsRefreshPanelBody } from "./DocumentSectionsRefreshPanelBody";
import { useDocumentSectionsRefreshPanel } from "./useDocumentSectionsRefreshPanel";

/** Results panel for a document_sections_refresh batch job. */
export const DocumentSectionsRefreshPanel = memo(function DocumentSectionsRefreshPanel({
  job,
}: BatchJobPanelProps) {
  const panel = useDocumentSectionsRefreshPanel(job);
  return <DocumentSectionsRefreshPanelBody panel={panel} />;
});
